import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Input, Space, Button, Row, Col, Select, Checkbox } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import { buildPhonesPayload, genderOptions, mergePhonesWithConfirmations } from '@/utils/helpers';
import { createCustomer, fetchNextMedicalBookNumber } from '@/redux/actions/customerActions';
import InputMask from "react-input-mask";
import moment from 'moment';
import _ from 'lodash';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { SaveOutlined } from '@ant-design/icons';
import PhoneDuplicateRelationModal from './PhoneDuplicateRelationModal';

class CustomerAddForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            customer_family: [],
            hasSetMedicalBookNumber: false,
            phoneDuplicateModalVisible: false,
            phoneDuplicateData: {},
            pendingValues: null
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible && !this.state.hasSetMedicalBookNumber) {
            this.props.fetchNextMedicalBookNumber().then(nextCode => {
                this.props.form.setFieldsValue({ medical_book_number: nextCode });
                this.setState({ hasSetMedicalBookNumber: true });
            });
        }

        // Reset lại khi đóng form để lần mở sau vẫn fetch mới
        if (!this.props.visible && prevProps.visible) {
            this.setState({ hasSetMedicalBookNumber: false });
        }
    }

    async submit(e) {
        e.preventDefault();

        this.props.form.validateFields(async (err, values) => {
            if (err) return;

            try {
                this.setState({ isLoading: true });

                const phonesRaw = values.phones || [];

                // STEP 1: SOFT
                const phonesSoft = buildPhonesPayload(phonesRaw);

                const softPayload = {
                    ...values,
                    phones: phonesSoft,
                    mode: 'soft',
                    customer_family: this.state.customer_family,
                    source_type: 'from_manual',
                };

                console.log('SUBMIT PAYLOAD (SOFT):', softPayload);

                await this.props.createCustomer(softPayload);

                this.props.reloadData();
                this.onClose();

            } catch (error) {
                const res = error?.response?.data;

                // BACKEND SOFT DUPLICATE
                if (res?.data?.type === 'PHONE_DUPLICATE_SOFT') {
                    this.setState({
                        phoneDuplicateModalVisible: true,
                        phoneDuplicateData: res.data.phones,
                        pendingValues: values,
                        isLoading: false,
                    });

                    return;
                }

                this.setState({ isLoading: false });
            }
        });
    }

    handleSubmitHard = async (phonesConfirmedFromModal, customerFamily) => {

        try {
            this.setState({ isLoading: true });

            const { pendingValues, customer_family } = this.state;

            // 1. Lấy danh sách phone gốc user nhập
            const rawPhones = pendingValues.phones || [];

            // 2. MERGE phone gốc + xác nhận từ modal
            const phonesHard = mergePhonesWithConfirmations(
                rawPhones,
                phonesConfirmedFromModal
            );

            // 3. Merge family (giữ logic hiện tại của bạn – ĐÚNG)
            const mergedCustomerFamily = _.uniqBy(
                [...customer_family, ...customerFamily],
                'related_id'
            );

            const hardPayload = {
                ...pendingValues,
                phones: phonesHard,
                mode: 'hard',
                customer_family: mergedCustomerFamily,
                source_type: 'from_manual',
            };

            console.log('SUBMIT PAYLOAD (HARD):', hardPayload);

            await this.props.createCustomer(hardPayload);

            this.setState({
                phoneDuplicateModalVisible: false,
                phoneDuplicateData: {},
                pendingValues: null,
                isLoading: false,
            });

            this.props.reloadData();
            this.onClose();

        } catch (error) {
            this.setState({ isLoading: false });
        }
    };

    handleClosePhoneDuplicateModal = () => {
        this.setState({
            phoneDuplicateModalVisible: false,
            phoneDuplicateData: {},
            pendingValues: null,
        });
    };


    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({ isLoading: false });
    }

    handleBirthdayChange = (e) => {
        const value = e.target.value;
        const date = moment(value, "DD/MM/YYYY", true);

        if (date.isValid()) {
            const age = moment().diff(date, "years");
            this.props.form.setFieldsValue({ age });
        } else {
            this.props.form.setFieldsValue({ age: "" });
        }
    };

    render() {
        var {
            isLoading
        } = this.state;
        var {
            visible,
            filterData
        } = this.props;

        const customerStatusActiveList = filterData.statuses;
        const customer_source_active_list = filterData.sources;
        const branchActiveList = filterData.branches;

        const { getFieldError, getFieldDecorator, getFieldValue } = this.props.form;

        const noPhone = getFieldValue('no_phone');
        const phoneErrors = getFieldError('phones');
        const showPhoneError = !noPhone && phoneErrors && phoneErrors.length;

        const otherErrors = getFieldError('other_contact');
        const showOtherError = noPhone && otherErrors && otherErrors.length;

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Thêm khách hàng mới"
                    onOk={(e) => this.submit(e)}
                    onClose={() => this.onClose()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '70%'}
                    footer={
                        <div style={{ textAlign: 'right', }}>
                            <Space>
                                <Button key="back" size='large' onClick={() => this.onClose()}>
                                    Huỷ
                                </Button>
                                <Button
                                    loading={isLoading}
                                    key="submit"
                                    type="primary"
                                    onClick={(e) => this.submit(e)}
                                    size='large'
                                    icon={<SaveOutlined />}
                                >
                                    Thêm
                                </Button>
                            </Space>
                        </div>
                    }
                >
                    {visible ?
                        <Form layout='vertical'>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Row gutter={16}>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Tên khách hàng">
                                                {getFieldDecorator('full_name', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: ""
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Nickname">
                                                {getFieldDecorator('fb_name', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng điền!',
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Cơ sở">
                                                {getFieldDecorator('branch_id', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng chọn',
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(
                                                    <BaseSelect
                                                        options={branchActiveList || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        placeholder="Chọn một bản ghi"
                                                        className="w-100"
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={16}>
                                            <Form.Item
                                                label="Số điện thoại"
                                                validateStatus={showPhoneError ? 'error' : null}
                                                help={showPhoneError ? phoneErrors[0] : null}
                                            >
                                                {getFieldDecorator("phones", {
                                                    initialValue: [],
                                                    rules: noPhone
                                                        ? []
                                                        : [
                                                            {
                                                                required: true,
                                                                message: "Vui lòng nhập số điện thoại hoặc tích 'Khách không cung cấp SĐT'",
                                                            },
                                                        ],
                                                })(
                                                    <Select
                                                        mode="tags"
                                                        style={{ width: '100%' }}
                                                        placeholder="Nhập SĐT, cách nhau bằng dấu phẩy"
                                                        tokenSeparators={[',']}
                                                        open={false}
                                                        disabled={noPhone}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item style={{ marginTop: -8 }}>
                                                {getFieldDecorator('no_phone', {
                                                    valuePropName: 'checked',
                                                    initialValue: false,
                                                })(
                                                    <Checkbox
                                                        onChange={e => {
                                                            if (e.target.checked) {
                                                                // Clear phone
                                                                this.props.form.setFields({
                                                                    phones: { value: [], errors: [] },
                                                                });
                                                            } else {
                                                                // Clear other contact
                                                                this.props.form.setFields({
                                                                    other_contact: { value: null, errors: [] },
                                                                });
                                                            }
                                                            this.forceUpdate();
                                                        }}
                                                    >
                                                        Khách không cung cấp số điện thoại
                                                    </Checkbox>
                                                )}
                                            </Form.Item>
                                            {noPhone && (
                                                <Form.Item
                                                    label="Phương thức liên hệ khác"
                                                    validateStatus={showOtherError ? 'error' : null}
                                                    help={showOtherError ? otherErrors[0] : null}
                                                >
                                                    {getFieldDecorator("other_contact", {
                                                        initialValue: null,
                                                        rules: noPhone
                                                            ? [
                                                                {
                                                                    required: true,
                                                                    message: "Vui lòng nhập phương thức liên hệ khác (Facebook, Zalo, Email...)",
                                                                },
                                                            ]
                                                            : [],
                                                    })(
                                                        <Input
                                                            placeholder="Ví dụ: Facebook, Zalo, Email, Telegram..."
                                                        />
                                                    )}
                                                </Form.Item>
                                            )}
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Giới tính">
                                                {getFieldDecorator("gender", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: "Vui lòng chọn",
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(
                                                    <BaseRadioList
                                                        options={genderOptions || []}
                                                        placeholder="Chọn một bản ghi"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Nguồn">
                                                {getFieldDecorator("customer_source_id", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: "Vui lòng chọn",
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(
                                                    <BaseSelect
                                                        options={customer_source_active_list || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        showSearch
                                                        placeholder="Chọn một bản ghi"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Năm sinh">
                                                {getFieldDecorator('birthday', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(
                                                    <InputMask
                                                        mask="99/99/9999"
                                                        placeholder="dd/mm/yyyy"
                                                        onChange={e => {
                                                            this.handleBirthdayChange(e);
                                                        }}
                                                    >
                                                        {(inputProps) => <Input {...inputProps} />}
                                                    </InputMask>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Tuổi">
                                                {getFieldDecorator("age", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label='Trạng thái'>
                                                {getFieldDecorator("customer_status_id", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng chọn",
                                                        },
                                                    ],
                                                    initialValue: null,
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <BaseSelect
                                                        options={customerStatusActiveList || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        showSearch
                                                        placeholder="Chọn một bản ghi"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Mã số sổ khám">
                                                {getFieldDecorator("medical_book_number", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={16} className='mt-3'>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ghi chú">
                                        {getFieldDecorator('note', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền",
                                                },
                                            ],
                                            initialValue: ""
                                        })(
                                            <Input.TextArea rows={4} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        : null}
                </Drawer>

                <PhoneDuplicateRelationModal
                    visible={this.state.phoneDuplicateModalVisible}
                    duplicateData={this.state.phoneDuplicateData}
                    loading={isLoading}
                    onCancel={this.handleClosePhoneDuplicateModal}
                    onConfirm={({ phonesConfirmedFromModal, customerFamily }) => {
                        this.handleSubmitHard(phonesConfirmedFromModal, customerFamily);
                    }}
                />
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.config.users,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createCustomer: (data) => dispatch(createCustomer(data)),
        fetchNextMedicalBookNumber: () => dispatch(fetchNextMedicalBookNumber()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerAddForm' })(CustomerAddForm));